export default __webpack_public_path__ + "static/media/video.c9b169f3.png";